import { Button, Conditional } from 'iq-blueberry'
import PropTypes from 'prop-types'
import OutlineArrowLeft from 'iq-blueberry/dist/reactIcons/OutlineArrowLeft'

import './style.styl'

const ActionButtons = ({
  formData,
  onGoBack,
  onSubmit,
  isStepValid,
  showBackButton = true,
  beforeSubmitStep,
  currentStep,
  continueLabel = 'Continuar',
  goBackLabel = 'Voltar',
  payload,
}) => {
  const usedStepValid = isStepValid !== undefined ? isStepValid : formData?.isFormValid
  const usedPayload = formData?.payload || payload
  const usedCurrentStep = formData?.currentStep || currentStep

  function submitHandler() {
    if (!!beforeSubmitStep) {
      beforeSubmitStep({
        currentStep: usedCurrentStep,
        isFormValid: usedStepValid,
        payload: usedPayload,
      })
    }
    if (!!formData) {
      formData?.handleSubmit()
    } else if (!!onSubmit) {
      onSubmit()
    }
  }

  return (
    <div className="action-buttons">
      <Conditional
        condition={!!showBackButton}
        renderIf={
          <div className="action-buttons__left">
            <Button
              expand="x"
              onClick={onGoBack}
              type="text"
              Icon={OutlineArrowLeft}>
              {goBackLabel}
            </Button>
          </div>
        }
      />
      <div className="background-button-continue">
        <div className="action-buttons__right">
          <Button
            expand="x"
            onClick={submitHandler}
            justify="center"
            disabled={!usedStepValid}>
            {continueLabel}
          </Button>
        </div>
      </div>
    </div>
  )
}

ActionButtons.propTypes = {
  formData: PropTypes.shape({
    isFormValid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  }),
  onGoBack: PropTypes.func,
  beforeSubmitStep: PropTypes.func,
}

export default ActionButtons
